import type { AllowedLocales, I18NConfig, Locale } from './types/types';

export const defaultLocale: Locale = 'de';

export const allowedLocales: AllowedLocales = [defaultLocale, 'en', 'nl'];

export const allowedLocalesMMCM: AllowedLocales = [defaultLocale, 'en'];

export const setMMCMLocale = (locale: Locale): string => {
  if (allowedLocalesMMCM.includes(locale)) {
    return locale;
  }
  return 'en';
};

export const i18nConfig: I18NConfig = {
  locales: allowedLocales,
  defaultLocale,
  prefixDefault: true,
  serverSetCookie: 'always',
};
